mutation StopYouTubeChatSession($eventId: ID, $channelId: String) {
  session: StreamToolsStopYouTubeChatSession(eventId: $eventId, channelId: $channelId) {
    sessionId
    eventId
    scope
    status
    startedAt
    stoppedAt
    stopReason
    channelId
    channelTitle
    videoId
    channelProfileImageUrl
    foreignEvent
  }
}
